import { DEFAULT_TILE_SIZE, getMaxSquare } from './getMaxSquare';
import { useSortProducts } from './useSortProducts';
import { useWindowSize } from '../../CustomerPickupScreen/hooks/useWindowSize';

import { useMemo } from 'react';

export function useTileSize() {
    const sortedProducts = useSortProducts();
    const productSize = sortedProducts.length;

    const windowSize = useWindowSize();

    const tileSize = useMemo(() => {
        if (!windowSize.width || !windowSize.height) return DEFAULT_TILE_SIZE;

        const SCALEDOWN = 0.9;
        const width = windowSize.width * SCALEDOWN;
        const height = windowSize.height * SCALEDOWN;

        if (productSize === 0) {
            return DEFAULT_TILE_SIZE;
        }

        return getMaxSquare(width, height, productSize);
    }, [windowSize.width, windowSize.height, productSize]);

    return tileSize;
}
